module.exports = {"rows_per_page":"Filas por página","out_of_pages":"de","all":"Todas","search_data":"Buscar datos"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-materialize-datatable/src/locales/es.json
// module id = vpMq
// module chunks = 1